// import React, { useEffect, useState } from "react";
// import { Typography, Spin } from 'antd';
// import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
// import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
// const { Title } = Typography;

// const ConsumerMarketPlace = () => {
//     const [loading, setLoading] = useState(false);

//     useEffect(() => {
//         setLoading(false);
//     }, []);

//     return (
//         <Spin spinning={loading}>
//             <SidebarLayoutConsumer>
//                 <div style={{ marginRight: "18px" }}>
//                     {/* <Title level={3} style={{ margin: "0 0 20px 0" }}>
//                         Marketplace
//                     </Title> */}
//                     <div
//                         style={{
//                             height: 'calc(80vh - 100px)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             textAlign: 'center',
//                             padding: 24,
//                         }}
//                     >
//                         <div>
//                             <Title level={2} style={{ marginBottom: 8,color:"white" }}>
//                                 Coming Soon
//                             </Title>
//                         </div>
//                     </div>
//                 </div>
//             </SidebarLayoutConsumer>
//         </Spin>
//     );
// };

// export default ConsumerMarketPlace;

import React, { useEffect, useState } from "react";
import { Typography, Spin, Input, Card, Badge, Button, Space, Tag, Row, Col, Statistic } from 'antd';
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { routes } from "../../../routes/Routes";


import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
const { Title, Text, Paragraph } = Typography;

const data = {
    funds: [
        {
            id: "sequoia-capital-fund-xvi",
            name: "Sequoia Capital Fund XVI",
            status: "Active",
            firm: "Sequoia Capital",
            category: "Venture Capital",
            vintageYear: 2021,
            interestSize: 125000000,
            currentNAV: 142000000,
            irr: 18.2,
            leverage: 0,
            valuationDate: "Q3 2025",
        },
        {
            id: "blackstone-real-estate-partners-ix",
            name: "Blackstone Real Estate Partners IX",
            status: "Active",
            firm: "Blackstone",
            category: "Real Estate",
            vintageYear: 2019,
            interestSize: 85000000,
            currentNAV: 96000000,
            irr: 12.5,
            leverage: 35,
            valuationDate: "Q4 2025",
        },
        {
            id: "apollo-credit-fund-iv",
            name: "Apollo Credit Fund IV",
            status: "Active",
            firm: "Apollo Global Management",
            category: "Private Credit",
            vintageYear: 2020,
            interestSize: 200000000,
            currentNAV: 218000000,
            irr: 9.8,
            leverage: 45,
            valuationDate: "Q3 2025",
        },
        {
            id: "andreessen-horowitz-fund-vii",
            name: "Andreessen Horowitz Fund VII",
            status: "Active",
            firm: "a16z",
            category: "Venture Capital",
            vintageYear: 2022,
            interestSize: 95000000,
            currentNAV: 89000000,
            irr: -6.3,
            leverage: 0,
            valuationDate: "Q4 2025",
        },
        {
            id: "kkr-americas-fund-xiii",
            name: "KKR Americas Fund XIII",
            status: "Active",
            firm: "KKR",
            category: "Buyout",
            vintageYear: 2018,
            interestSize: 310000000,
            currentNAV: 402000000,
            irr: 24.1,
            leverage: 52,
            valuationDate: "Q3 2025",
        },
        {
            id: "tpg-growth-v",
            name: "TPG Growth V",
            status: "Active",
            firm: "TPG",
            category: "Growth Equity",
            vintageYear: 2020,
            interestSize: 175000000,
            currentNAV: 201000000,
            irr: 14.9,
            leverage: 25,
            valuationDate: "Q4 2025",
        },
    ],
};

const ASSET_FILTERS = [
    "All Asset Classes",
    "Venture Capital",
    "Buyout",
    "Growth Equity",
    "Real Estate",
    "Private Credit",
];

const formatMoney = (n) => `$${(n / 1e6).toFixed(0)}M`;

const ConsumerMarketPlace = () => {
    const history = useHistory();
    const routerHistory = useHistory();


    const [loading, setLoading] = useState(false);
    const [activeFilter, setActiveFilter] = useState("All Asset Classes");
    const [searchTerm, setSearchTerm] = useState("");


    const filteredFunds = data.funds.filter(fund => {
        const matchesCategory = activeFilter === "All Asset Classes" || fund.category === activeFilter;
        const matchesSearch = fund.name.toLowerCase().includes(searchTerm.toLowerCase()) || fund.firm.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesCategory && matchesSearch;
    });

    const OnClick = () => {
        routerHistory.push("/secondaryMarketDetail");
    };

    return (
        <Spin spinning={loading}>
            <SidebarLayoutConsumer>
                <div className="market-container">
                    <header className="market-header">
                        <Title level={3} className="page-title">Secondary Market</Title>
                        <Paragraph className="subtitle">
                            Discover and transact liquid private market interests across asset classes
                        </Paragraph>
                    </header>

                    <div className="market-controls">
                        <Input
                            className="search-input"
                            placeholder="Search by fund name or manager..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            prefix={<SearchOutlined />}
                        />
                        <Button 
                            className="filter-btn"
                            icon={<FilterOutlined />}
                        >
                            Filters
                        </Button>
                    </div>
                    
                    <div className="asset-tabs responsive-tabs">
                        {ASSET_FILTERS.map(item => (
                            <Tag
                                key={item}
                                className={`asset-tab ${activeFilter === item ? "active" : ""}`}
                                color={activeFilter === item ? "blue" : "default"}
                                onClick={() => setActiveFilter(item)}
                            >
                                {item}
                            </Tag>
                        ))}
                    </div>

                    <div className="fund-grid">
                        {filteredFunds.map(fund => (
                            <Card className="fund-card" key={fund.id} hoverable>
                                <div className="fund-card-top">
                                    <div className="fund-title-row">
                                        <Title level={5}>{fund.name}</Title>
                                        <Tag className="status-badge">{fund.status}</Tag>
                                    </div>
                                    <div style={{ marginBottom: "18px" }}>
                                        <Text className="fund-meta" type="secondary">
                                            {fund.firm}
                                        </Text>
                                    </div>
                                    <div className="fund-area" >
                                        <Text type="secondary">
                                            <img className="icon" src={`${process.env.PUBLIC_URL}/building.svg`} alt="Building" /> <span className="text" >{fund.category}</span> <span className="text">•</span> 
                                            <img className="icon" src={`${process.env.PUBLIC_URL}/calender.svg`} alt="Calendar" /> <span className="text" >{fund.vintageYear} </span> 
                                        </Text>
                                    </div>
                                    {/* • {fund.vintageYear} */}
                                    <div className="fund-stats">
                                        <div>
                                            <span>Interest Size</span>
                                            <strong>{formatMoney(fund.interestSize)}</strong>
                                        </div>
                                        <div>
                                            <span>Current NAV</span>
                                            <strong>{formatMoney(fund.currentNAV)}</strong>
                                        </div>
                                        <div>
                                            <span>IRR</span>
                                            <strong className={fund.irr < 0 ? "negative" : "positive"}>
                                                {fund.irr}%
                                            </strong>
                                        </div>
                                        <div>
                                            <span>Leverage</span>
                                            <strong>{fund.leverage}%</strong>
                                        </div>
                                    </div>
                                </div>
                                <div className="fund-card-bottom">
                                    <Text className="valuation" type="secondary">
                                        Valuation Date: {fund.valuationDate}
                                    </Text>
                                    <Button
                                        className="details-btn"
                                        type="primary"
                                        onClick={OnClick}
                                    >
                                        View Details
                                    </Button>
                                </div>
                            </Card>
                        ))}
                    </div>
                </div>
            </SidebarLayoutConsumer>
        </Spin>
    );
}
export default ConsumerMarketPlace